import React, { createContext, useEffect, useRef, useState } from 'react';
import { getempDetails } from '../../components/inboundCenter';
import { get_ak } from './emploginService';
import getCookie, { setCookie } from '../GetCookie/getCookie';
import { decryptPII } from '../encryption/aesEncryption';

const EmployeeContext = createContext();

export const EmployeeProvider = ({ children }) => {
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const hasFetched = useRef(false);

  const urlParams = new URLSearchParams(window.location.search);
  const empid = urlParams.get('empid');

  useEffect(() => {
      if (!empid || hasFetched.current) return;
      hasFetched.current = true;

      // Read all params at call time so we capture the URL state when empid is first available
      const p = new URLSearchParams(window.location.search);
      // Decrypt phone parameters (supports both encrypted and unencrypted for backward compatibility)
      const ONum = decryptPII(p.get('origNum') || "");
      const phone = decryptPII(p.get('phone') || "");
      const ucid = p.get('crtObjectId') || "";
      const type = p.get('type') || "";

      async function fetchEmployeeDetails() {
          try {
              let ak = getCookie("jwt_token");
              if (!ak) {
                  window.location.href = window.location.origin;
                  return;
              }
              let data = await getempDetails(empid, ak);
              data['ak'] = ak;
              data['empid'] = empid;
              data['ONum'] = ONum || phone;
              data['ucid'] = ucid;
              data['type'] = type;
              setCookie("employeeData", JSON.stringify(data));
              setEmployeeDetails(data);
          } catch (error) {
              console.error('Error fetching employee details:', error);
          }
      }

      fetchEmployeeDetails();
  }, [empid]);

  return (
    <EmployeeContext.Provider value={employeeDetails}>
      {children}
    </EmployeeContext.Provider>
  );
};

export default EmployeeContext;
